import { render, staticRenderFns } from "./DNSMissingTXTContainer.vue?vue&type=template&id=1a47bba8&scoped=true&lang=html&"
import script from "./DNSMissingTXTContainer.vue?vue&type=script&lang=js&"
export * from "./DNSMissingTXTContainer.vue?vue&type=script&lang=js&"
import style0 from "./DNSMissingTXTContainer.vue?vue&type=style&index=0&id=1a47bba8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a47bba8",
  null
  
)

export default component.exports